<template>
  <div class="container">
    <div class="white-frame" v-if="stage == 1">
      <div class="title-text mb-3"><b>Formulário Registro</b></div>
      <!-- Formulario registo -->
      <div class="row g-3">
        <div class="col-md-6" :class="{ 'field-required': $v.registerForm.nome.$invalid }">
          <label for="nome" class="form-label">Nome completo</label>
          <InputText id="nome" v-model="registerForm.nome" class="form-control" />
        </div>
        <div class="col-md-6" :class="{ 'field-required': $v.registerForm.email.$invalid }">
          <label for="email" class="form-label">Email</label>
          <InputText id="email" v-model="registerForm.email" class="form-control" />
        </div>
        <div class="col-md-6" :class="{ 'field-required': $v.registerForm.telefone.$invalid }">
          <label for="telefone" class="form-label">Telefone fixo</label>
          <!-- <InputMask
            id="telefone"
            mask="(99) 9999-9999"
            :unmask="true"
            v-model="registerForm.telefone"
            class="form-control"
          /> -->
          <imask-input
            id="telefone"
            v-model="registerForm.telefone"
            class="form-control p-inputtext p-component"
            :mask="masks.telefone"
            :unmask="true"
          />
        </div>
        <div class="col-md-6" :class="{ 'field-required': $v.registerForm.telemovel.$invalid }">
          <label for="telemovel" class="form-label">Telefone celular</label>
          <!-- <InputMask
            id="telemovel"
            mask="(99) 99999-9999"
            :unmask="true"
            v-model="registerForm.telemovel"
            class="form-control"
          /> -->
          <imask-input
            ref="teste"
            id="telemovel"
            v-model="registerForm.telemovel"
            class="form-control p-inputtext p-component"
            :mask="masks.telemovel"
            :unmask="true"
            @complete="setTelemovelMask"
          />
        </div>
        <div class="col-md-6" :class="{ 'field-required': $v.registerForm.cpf.$invalid }">
          <label for="cpf" class="form-label">CPF</label>
          <!-- <InputMask
            id="cpf"
            mask="999.999.999-99"
            :unmask="true"
            v-model="registerForm.cpf"
            class="form-control"
          /> -->
          <imask-input
            id="cpf"
            type="text"
            v-model="registerForm.cpf"
            class="form-control p-inputtext p-component"
            :mask="masks.maskCpf"
            :unmask="true"
          />
        </div>
        <div class="col-md-6" :class="{ 'field-required': $v.registerForm.morada.$invalid }">
          <label for="morada" class="form-label">Endereço Residencial</label>
          <InputText id="morada" v-model="registerForm.morada" class="form-control" />
        </div>
        <div v-if="!$v.registerForm.$invalid" class="col-12 Aligner aligner-right">
          <button
            @click="generateValidationTokens"
            :disabled="stage == 2"
            class="button-base-small btn-blue font-small"
          >
            <i v-if="stage == 2" class="fa fa-spinner"></i>
            {{ stage == 2 ? 'Aguarde...' : 'Avançar' }}
          </button>

          <!-- <button
            @click="generateValidationTokens"
            class="button-base-small btn-green font-small mx-1"
          >
            Avançar
          </button> -->
        </div>
      </div>
    </div>
    <!-- Verificacao do token -->
    <div class="white-frame" v-if="stage == 2">
      <div class="title-text mb-3"><b>Verificação Tokens</b></div>

      <!-- Dev Mode Helper - Apenas exibido em ambiente de desenvolvimento -->
      <div v-if="isDevelopment && devTokens.enabled" class="alert alert-info mb-3">
        <h5><i class="fa fa-info-circle"></i> Modo Desenvolvimento</h5>
        <p
          >Email Token: <strong>{{ devTokens.defaultEmailToken }}</strong></p
        >
        <p
          >SMS Token: <strong>{{ devTokens.defaultSmsToken }}</strong></p
        >
        <p class="mb-0"
          ><small>Tokens fixos para ambiente de desenvolvimento, sem envio por email/SMS.</small></p
        >
      </div>

      <div class="row g-3">
        <div class="col-md-6" :class="{ 'field-required': $v.tokens.email.$invalid }">
          <label for="tokenEmail" class="form-label"
            >Email token
            <span class="badge rounded-pill bg-primary">{{ registerForm.email }}</span></label
          >
          <InputText id="tokenEmail" v-model="tokens.email" class="form-control" />
        </div>
        <div class="col-md-6">
          <component
            :is="captchaComponent"
            ref="captcha"
            :sitekey="captchaKey"
            @verify="captchaValidate"
            @expired="captchaExpired"
            @error="captchaError"
            :loadRecaptchaScript="!isDevelopment"
          >
          </component>
        </div>
        <!-- <div
          class="col-md-6"
          :class="{ 'field-required': $v.tokens.sms.$invalid }"
        >
          <label for="tokenSms" class="form-label"
            >Sms token
            <span class="badge rounded-pill bg-primary">{{
              registerForm.telemovelMask
            }}</span></label
          >
          <InputText id="tokenSms" v-model="tokens.sms" class="form-control" />
        </div> -->
        <div class="col-12 Aligner aligner-right">
          <button @click="goBack" class="button-base-small btn-grey font-small"> Voltar </button>
          <button
            @click="generateValidationTokens"
            v-if="timerCount == 0"
            class="button-base-small btn-blue font-small"
          >
            Reenviar codigos
          </button>
          <button
            v-if="!$v.tokens.email.$invalid && timerCount != 0 && tokens.captchaValid"
            @click="validateTokens"
            class="button-base-small btn-blue font-small mx-1"
          >
            Avançar <i class="fa fa-chevron-right ms-3"></i>
          </button>
        </div>
      </div>
      <div class="row" v-if="timerCount > 0">
        <div class="col">
          <div class="timer-token">
            <div class="timer-spin">
              <svg class="timer-spin-anim-01" width="16" height="16" viewBox="0 0 16 16">
                <path d="M15 8c0 3.9-3.1 7-7 7s-7-3-7-7h-1c0 4 3.6 8 8 8s8-3.6 8-8h-1z"></path>
              </svg>
              <svg class="timer-spin-anim-02" width="16" height="16" viewBox="0 0 16 16">
                <path d="M15 8c0 3.9-3.1 7-7 7s-7-3-7-7h-1c0 4 3.6 8 8 8s8-3.6 8-8h-1z"></path>
              </svg>
            </div>
            <div class="timer-round-01">
              <div>{{ timerCount }}</div>
            </div>
          </div>
        </div>
        <!-- <Chip v-if="timerCount > 0" :label="timerCount.toString()" /> -->
        <Message v-if="timerCount == 0" severity="error"
          >Será necessario pedir novos tokens</Message
        >
      </div>
    </div>
    <loading-state-f-s v-if="stage == 0" />
  </div>
</template>

<script>
  import Swal from 'sweetalert2';
  import VueRecaptcha from 'vue-recaptcha';
  import { mapActions } from 'vuex';
  import { required, email, minLength } from 'vuelidate/lib/validators';
  import { IMaskComponent } from 'vue-imask';
  import { cpfValid, inputClean, moreThan2Words } from '../utils/customValidations';
  import LoadingStateFS from './LoadingStateFS.vue';
  import { swalConfig, timerSecondsSetting } from '../utils/constants';
  import { isDevelopment, mockTokens } from '../utils/dev-env';
  import { captchaConfig } from '../utils/env-config';
  import MockCaptcha from './Mocks/MockCaptcha.vue';

  export default {
    components: {
      LoadingStateFS,
      'imask-input': IMaskComponent,
      VueRecaptcha,
      MockCaptcha
    },
    data() {
      return {
        stage: 1,
        timerCount: 0,
        captchaKey: captchaConfig.siteKey,
        isDevelopment,
        registerForm: {
          nome: '',
          email: '',
          telefone: '',
          telemovel: '',
          cpf: '',
          morada: '',
          telemovelMask: ''
        },
        tokens: {
          sms: '',
          email: '',
          captcha: '',
          captchaValid: false
        },
        masks: {
          maskCpf: [
            {
              mask: '000.000.000-00'
            }
          ],
          telemovel: [
            {
              mask: '(00) 00000-0000',
              lazy: false
            }
          ],
          telefone: [
            {
              mask: '(00) 0000-0000',
              lazy: false
            }
          ]
        }
      };
    },
    computed: {
      captchaComponent() {
        return this.isDevelopment ? 'MockCaptcha' : 'VueRecaptcha';
      },
      devTokens() {
        return mockTokens;
      }
    },
    validations() {
      return {
        registerForm: {
          nome: { required, moreThan2Words, inputClean },
          email: { required, email },
          telefone: this.registerForm.telefone != '' ? { minLength: minLength(10) } : {},
          telemovel: { required, minLength: minLength(11) },
          cpf: { required, cpfValid },
          morada: { required, inputClean }
        },
        tokens: {
          sms: { required },
          email: { required }
        }
      };
    },
    methods: {
      ...mapActions(['register', 'validate', 'getDTO']),
      async generateValidationTokens() {
        this.stage = 0;
        await this.register(this.registerForm);
        this.stage = 2;
        this.timerCount = timerSecondsSetting;
      },
      async validateTokens() {
        this.stage = 0;
        const res = await this.validate(this.tokens);
        if (!res || !this.tokens.captchaValid) {
          this.tokens.captchaValid = false;
          Swal.fire({
            ...swalConfig,
            icon: 'error',
            title: 'Erro',
            text: 'Um ou mais tokens inválidos.'
          });
          this.stage = 2;
        }
      },
      goBack() {
        this.stage = 1;
        this.tokens.sms = null;
        this.tokens.email = null;
        this.tokens.captchaValid = false;
      },
      setTelemovelMask() {
        this.registerForm.telemovelMask = this.$refs.teste.maskRef._value;
      },
      captchaValidate(response) {
        this.tokens.captcha = response;
        this.tokens.captchaValid = true;
      },
      captchaExpired() {
        this.$refs.captcha.reset();
        this.tokens.captchaValid = false;
      },
      captchaError() {
        this.$refs.captcha.reset();
        this.tokens.captchaValid = false;
      }
    },
    watch: {
      timerCount: {
        handler(value) {
          if (value > 0) {
            setTimeout(() => {
              this.timerCount--;
            }, 1000);
          }
        },
        immediate: false
      }
    },
    // beforeMount(){
    //   this.timerCount = timerSecondsSetting;
    //   this.captchaKey = captchaKeySetting;
    // },
    mounted() {
      this.getDTO();
      this.tokens.captchaValid = false;
    }
  };
</script>
